var _circle, _path, _path2, _path3, _circle2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPageAvailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 81,
    viewBox: "0 0 100 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5898,
    cy: 53.2852,
    r: 27.5898,
    fill: "#FD3757",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3633 29.6641C73.4465 29.6641 84.8633 25.8585 84.8633 21.1641C84.8633 16.4696 73.4465 12.6641 59.3633 12.6641C45.28 12.6641 33.8633 16.4696 33.8633 21.1641C33.8633 25.8585 45.28 29.6641 59.3633 29.6641Z",
    stroke: "#FD3757",
    strokeWidth: 5.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8633 21.1641V60.8307C33.8633 63.0851 36.5499 65.2471 41.3321 66.8411C46.1142 68.4352 52.6003 69.3307 59.3633 69.3307C66.1263 69.3307 72.6123 68.4352 77.3945 66.8411C82.1767 65.2471 84.8633 63.0851 84.8633 60.8307V21.1641",
    stroke: "#FD3757",
    strokeWidth: 5.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8633 41C33.8633 43.2543 36.5499 45.4163 41.3321 47.0104C46.1142 48.6045 52.6003 49.5 59.3633 49.5C66.1263 49.5 72.6123 48.6045 77.3945 47.0104C82.1767 45.4163 84.8633 43.2543 84.8633 41",
    stroke: "#FD3757",
    strokeWidth: 5.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.3633,
    cy: 16,
    r: 16,
    fill: "#0F172A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3633 10L77.3633 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3633 10L89.3633 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPageAvailable);
export default __webpack_public_path__ + "static/media/NoPageAvailable.6efbad526627d576f95937ec5d643af1.svg";
export { ForwardRef as ReactComponent };